import React from 'react'

const TicketFormNextSectionButtons = ({ setNextModalSection, disabled }) => {
  return (
    <div className="form-section">
      <div className="form-section__actions">
        <button
          type="button"
          className="button button--outline form-section__action"
          onClick={() => { window.location.reload(true) }}
        >
          Cancel
        </button>
        <button
          type="button"
          className="button form-section__action"
          onClick={setNextModalSection}
          disabled={disabled}
          style={disabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
        >
          Next
        </button>
      </div>
    </div>
  )
}

export default TicketFormNextSectionButtons
